import { render } from "./MissingFacilitiesModal.vue?vue&type=template&id=c12324c2&ts=true"
import script from "./MissingFacilitiesModal.vue?vue&type=script&lang=ts"
export * from "./MissingFacilitiesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__